<template>
  <div class="news-detail">
    <div class="news-title">{{ detail.title }}</div>
    <div class="news-info">
      <div class="news-time">{{ detail.createTime }}</div>
      <div class="news-like">{{ detail.collectionCount }}</div>
    </div>
    <div class="news-content">{{ detail.text }}</div>
    <el-button class="return-button" @click="$router.back()">返回</el-button>
  </div>
</template>

<script>
import { fetchNewsDetail } from '@/api'

export default {
  data() {
    return {
      detail: ''
    }
  },

  mounted() {
    this.fetchDetail(this.$route.query.id)
  },

  methods: {
    fetchDetail(id) {
      fetchNewsDetail({
        id
      })
        .then(res => {
          res.data.picDetails = res.data.picDetails ? res.data.picDetails.split(';') : []

          this.detail = res.data
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    }
  }
}
</script>

<style lang='scss' scoped>
.news-detail {
    max-width: 1200px;
    background-color: #fff;
    border-radius: 4px;
    padding: 40px 30px;
    margin: 10px auto 0;
    .news-title {
        font-size: 26px;
        line-height: 40px;
        font-weight: bold;
    }
    .news-info {
        display: flex;
        align-items: center;
        color: #999;
        line-height: 15px;
        padding: 25px 0;
        border-bottom: 1px solid #F0F0F0;
        margin: 15px 0 0;
        .news-time, .news-like {
            background-repeat: no-repeat;
            background-position: center left;
            padding: 0 0 0 20px;
        }
        .news-time {
            background-image: url('~@/assets/images/icon-clock-blue.png');
        }
        .news-like {
            background-image: url('~@/assets/images/icon-like-red.png');
            margin: 0 0 0 44px;
        }
    }
    .news-content {
        color: #666;
        line-height: 26px;
        white-space: pre-wrap;
        margin: 46px 0;
    }
    .return-button {
        display: block;
        width: 240px;
        height: 44px;
        font-size: 16px;
        color: #417EF7;
        border-color: currentColor;
        background-color: #fff;
        margin: 0 auto;
    }
}
</style>
